import html2canvas from "html2canvas";

/**
 * FIXED VERSION:
 * - MapboxGL background loads using STATIC IMAGE API (guaranteed)
 * - WebGL canvas no longer causes blank export
 * - AntD tables & scroll containers still supported
 * - Loader + full restore included
 */
export const downloadSectionAsImage = async (
  elementId,
  filename = "section"
) => {
  const element = document.getElementById(elementId);
  if (!element) return;

  // --------- LOADER ----------
  const loader = document.createElement("div");
  Object.assign(loader.style, {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.35)",
    zIndex: "99999",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    fontSize: "20px",
    backdropFilter: "blur(2px)",
  });
  loader.innerHTML = `<div style="padding:20px;background:#222;border-radius:10px">⏳ Preparing download...</div>`;
  document.body.appendChild(loader);

  let mapCanvas = element.querySelector(".mapboxgl-canvas");
  let staticImg = null;

  // --------- STEP 1: MAPBOX STATIC API FALLBACK ----------
  if (mapCanvas) {
    try {
      // We get map instance: Mapbox attaches it on its parent container
      const mapContainer = mapCanvas.closest(".mapboxgl-map");
      const map = mapContainer.__mapInstance; // You MUST attach this (below)

      const center = map.getCenter();
      const zoom = map.getZoom();
      const style = "dark-v11"; // you can change based on your style

      const token = process.env.REACT_APP_MAPBOX_TOKEN;

      const width = mapCanvas.clientWidth;
      const height = mapCanvas.clientHeight;

      const staticURL =
        `https://api.mapbox.com/styles/v1/mapbox/${style}/static/` +
        `${center.lng},${center.lat},${zoom}/` +
        `${width}x${height}?access_token=${token}`;

      staticImg = document.createElement("img");
      staticImg.src = staticURL;
      staticImg.crossOrigin = "anonymous";
      staticImg.style.position = "absolute";
      staticImg.style.inset = "0";
      staticImg.style.width = "100%";
      staticImg.style.height = "100%";
      staticImg.style.zIndex = "0";

      mapCanvas.style.opacity = "0";
      mapCanvas.parentElement.appendChild(staticImg);
    } catch (err) {
      console.warn("⚠ Mapbox static image fallback failed:", err);
    }
  }

  // --------- STEP 2: EXPAND SCROLL + TABLES ----------
  const modified = [];
  const expand = (el) => {
    const c = window.getComputedStyle(el);
    const oY = c.getPropertyValue("overflow-y");
    const oX = c.getPropertyValue("overflow-x");

    const backup = {
      el,
      width: el.style.width,
      height: el.style.height,
      overflowX: el.style.overflowX,
      overflowY: el.style.overflowY,
    };

    if (oY === "auto" || oY === "scroll") {
      el.style.height = el.scrollHeight + "px";
      el.style.overflowY = "visible";
      modified.push(backup);
    }

    if (oX === "auto" || oX === "scroll") {
      el.style.width = el.scrollWidth + "px";
      el.style.overflowX = "visible";
      modified.push(backup);
    }
  };

  element.querySelectorAll("*").forEach(expand);

  // AntD Table special handling
  const antBody = element.querySelector(".ant-table-body");
  const antContent = element.querySelector(".ant-table-content");

  if (antContent) {
    modified.push({
      el: antContent,
      width: antContent.style.width,
      overflowX: antContent.style.overflowX,
    });
    antContent.style.width = antContent.scrollWidth + "px";
    antContent.style.overflowX = "visible";
  }

  if (antBody) {
    modified.push({
      el: antBody,
      width: antBody.style.width,
      height: antBody.style.height,
      overflowX: antBody.style.overflowX,
      overflowY: antBody.style.overflowY,
    });
    antBody.style.width = antBody.scrollWidth + "px";
    antBody.style.height = antBody.scrollHeight + "px";
    antBody.style.overflow = "visible";
  }

  await new Promise((r) => setTimeout(r, 300));

  // --------- STEP 3: CAPTURE ----------
  let canvas = await html2canvas(element, {
    scale: 2,
    useCORS: true,
    backgroundColor: "#ffffff",
  });

  const link = document.createElement("a");
  link.download = `${filename}.png`;
  link.href = canvas.toDataURL("image/png");
  link.click();

  // --------- STEP 4: RESTORE ----------
  modified.forEach((m) => {
    if (m.width !== undefined) m.el.style.width = m.width;
    if (m.height !== undefined) m.el.style.height = m.height;
    if (m.overflowX !== undefined) m.el.style.overflowX = m.overflowX;
    if (m.overflowY !== undefined) m.el.style.overflowY = m.overflowY;
  });

  if (mapCanvas && staticImg) {
    mapCanvas.style.opacity = "1";
    staticImg.remove();
  }

  loader.remove();

  // Optional full refresh
  window.location.reload();
};
